import { SlaRepository } from '../repositories/sla.repository'
import {
    SlaCalculateMinDeliveryDateParams,
    SlaCalculateMinDeliveryDateResponse,
    SlaCreatePayloadT,
    SlaCreateResponseT,
    SlaDeleteResponseT,
    SlaExportExcelParams,
    SlaGetListParams,
    SlaGetListResponseT,
    SlaUpdateResponseT,
} from '../types/sla.types'

const slaRepository = new SlaRepository()

export class SlaService {
    async getList(params: SlaGetListParams): Promise<SlaGetListResponseT> {
        const response = await slaRepository.getList(params)
        return response.data
    }

    async getListFtl(params: SlaGetListParams): Promise<SlaGetListResponseT> {
        const response = await slaRepository.getListFtl(params)
        return response.data
    }

    async createSLA(sla_payload: SlaCreatePayloadT): Promise<SlaCreateResponseT> {
        const response = await slaRepository.createSLA(sla_payload)
        return response.data
    }

    async createSlaFtl(sla_payload: SlaCreatePayloadT): Promise<SlaCreateResponseT> {
        const response = await slaRepository.createSlaFtl(sla_payload)
        return response.data
    }

    async updateSLA(sla_id: number, sla_payload: SlaCreatePayloadT): Promise<SlaUpdateResponseT> {
        const response = await slaRepository.updateSLA(sla_id, sla_payload)
        return response.data
    }

    async updateSlaFtl(
        sla_id: number,
        sla_payload: SlaCreatePayloadT
    ): Promise<SlaUpdateResponseT> {
        const response = await slaRepository.updateSlaFtl(sla_id, sla_payload)
        return response.data
    }

    async deleteSLA(sla_id: number): Promise<SlaDeleteResponseT> {
        await slaRepository.deleteSLA(sla_id)
    }

    async deleteSlaFtl(sla_id: number): Promise<SlaDeleteResponseT> {
        await slaRepository.deleteSlaFtl(sla_id)
    }

    async importFromExcel(form_data: FormData): Promise<void> {
        const response = await slaRepository.importFromExcel(form_data)
        return response.data
    }

    async exportExcel(params: SlaExportExcelParams): Promise<any> {
        const response = await slaRepository.exportExcel(params)
        return response.data
    }

    async calculateMinDeliveryDate(params: SlaCalculateMinDeliveryDateParams): Promise<SlaCalculateMinDeliveryDateResponse> {
        const response = await slaRepository.calculateMinDeliveryDate(params)
        return response.data
    }
}
